import LanguagesPage from "./languages-page";

const LanguagePages = {
    Archive : LanguagesPage
}

export default LanguagePages;